/**
 * License Inventory Constants
 */

export const TREND_DIRECTIONS = {
  UP: 'up',
  DOWN: 'down',
} as const;

export type TrendDirection =
  (typeof TREND_DIRECTIONS)[keyof typeof TREND_DIRECTIONS];

export const LICENSE_STATUSES = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  PENDING: 'Pending',
  EXPIRING: 'Expiring',
} as const;

export type LicenseStatus =
  (typeof LICENSE_STATUSES)[keyof typeof LICENSE_STATUSES];

export const LICENSE_RISKS = {
  LOW: 'Low',
  MEDIUM: 'Medium',
  ELEVATED: 'Elevated',
  HIGH: 'High',
} as const;

export type LicenseRisk = (typeof LICENSE_RISKS)[keyof typeof LICENSE_RISKS];

export const LICENSE_INVENTORY_SYMBOLS = {
  SLASH: '/',
  PERCENT: '%',
  DOLLAR: '$',
  PLUS: '+',
  PERCENT_YOY: '% YoY',
} as const;
